import React from 'react';
import { IStyledSVGIconProps, StyledSVGIcon } from './icon.style';

export const ComputerLaptopIcon: React.FC<IStyledSVGIconProps> = (props) => {
  return (
    <StyledSVGIcon
      version="1.1"
      id="icons"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 48 32"
      {...props}
    >
      <g>
        <rect x="6.4" y="4.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -1.3987 7.6206)" width="4.2" height="2" />
        <rect x="5.3" y="7" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.4391 10.116)" width="11.3" height="2" />
        <path d="M45,26V3c0-1.7-1.3-3-3-3H6C4.3,0,3,1.3,3,3v23H0v1c0,2.8,2.2,5,5,5h38c2.8,0,5-2.2,5-5v-1H45z M5,3
          c0-0.6,0.4-1,1-1h36c0.6,0,1,0.4,1,1v23H28.6l-1,1h-7.2l-1-1H5V3z M43,30H5c-1.3,0-2.4-0.8-2.8-2h16.4l1,1h8.8l1-1h16.4
          C45.4,29.2,44.3,30,43,30z"/>
      </g>
    </StyledSVGIcon>
  );
};